// Week 33 STEM Story: Corridor Safety & School Care
export default {
  id: "w33_read",
  week: 33,
  title: "Corridor Safety & School Care",
  title_vi: "An Toàn Hành Lang & Chăm Sóc Trường Học",
  cover_image: "/images/week33/read_cover_w33.jpg",
  audio_url: "/audio/week33/read_stem.mp3",
  content_en: "Jake was walking carefully down the school corridor after science class. His friend Tom was running very fast past the science room. Suddenly, he lost his balance on the wet floor and slipped. He fell down heavily and hurt his knee. Jake stopped immediately to help his friend stay calm. He called the school nurse right away. The nurse arrived quickly with a clean bandage and a cold pack to treat the cut. Everyone felt relieved, and the headmaster reminded all students never to run in corridors.",
  text_en: "Jake was walking carefully down the school corridor after science class. His friend Tom was running very fast past the science room. Suddenly, he lost his balance on the wet floor and slipped. He fell down heavily and hurt his knee. Jake stopped immediately to help his friend stay calm. He called the school nurse right away. The nurse arrived quickly with a clean bandage and a cold pack to treat the cut. Everyone felt relieved, and the headmaster reminded all students never to run in corridors.",
  content_vi: "Jake đang đi bộ cẩn thận xuống hành lang trường học sau giờ học khoa học. Bạn của cậu ấy là Tom đang chạy rất nhanh ngang qua phòng khoa học. Đột nhiên, cậu ấy bị mất thăng bằng trên sàn ướt và trượt chân. Cậu ấy ngã mạnh xuống sàn và bị đau đầu gối. Jake dừng lại ngay lập tức để giúp bạn mình giữ bình tĩnh. Cậu ấy gọi y tá trường ngay lập tức. Cô y tá đến nhanh chóng với một chiếc băng sạch và túi chườm lạnh để điều trị vết cắt. Mọi người đều cảm thấy nhẹ nhõm, và thầy hiệu trưởng nhắc nhở tất cả học sinh không bao giờ được chạy trong hành lang.",
  text_vi: "Jake đang đi bộ cẩn thận xuống hành lang trường học sau giờ học khoa học. Bạn của cậu ấy là Tom đang chạy rất nhanh ngang qua phòng khoa học. Đột nhiên, cậu ấy bị mất thăng bằng trên sàn ướt và trượt chân. Cậu ấy ngã mạnh xuống sàn và bị đau đầu gối. Jake dừng lại ngay lập tức để giúp bạn mình giữ bình tĩnh. Cậu ấy gọi y tá trường ngay lập tức. Cô y tá đến nhanh chóng với một chiếc băng sạch và túi chườm lạnh để điều trị vết cắt. Mọi người đều cảm thấy nhẹ nhõm, và thầy hiệu trưởng nhắc nhở tất cả học sinh không bao giờ được chạy trong hành lang.",

  story_scenes: [
    {
      scene_id: "scene_1",
      scene_number: 1,
      title_en: "Scene 1: Walking Down the Corridor",
      description_en: "Jake was **walking carefully** down the **school corridor** after **science class**.",
      description: "Jake was **walking carefully** down the **school corridor** after **science class**.",
      image_url: "/images/week33/webtoon_scene_1.png",
      audio_url: "/audio/week33/scene_1.mp3",
      lexical_chunks: [
        { word: "corridor", chunk: "school corridor", vi: "hành lang trường", x: 45, y: 40 },
        { word: "carefully", chunk: "walking carefully", vi: "đi bộ cẩn thận", x: 62, y: 55 },
        { word: "after", chunk: "after science class", vi: "sau giờ học khoa học", x: 22, y: 72 }
      ]
    },
    {
      scene_id: "scene_2",
      scene_number: 2,
      title_en: "Scene 2: Slipping on Wet Floor",
      description_en: "Suddenly, he **lost his balance** on the **wet floor** and slipped.",
      description: "Suddenly, he **lost his balance** on the **wet floor** and slipped.",
      image_url: "/images/week33/webtoon_scene_2.png",
      audio_url: "/audio/week33/scene_2.mp3",
      lexical_chunks: [
        { word: "balance", chunk: "lost his balance", vi: "mất thăng bằng", x: 62, y: 45 },
        { word: "floor", chunk: "wet floor", vi: "sàn ướt", x: 74, y: 68 },
        { word: "slipped", chunk: "and slipped", vi: "và trượt chân", x: 58, y: 82 }
      ]
    },
    {
      scene_id: "scene_3",
      scene_number: 3,
      title_en: "Scene 3: Helping Friend & Calling Nurse",
      description_en: "Jake **stopped immediately** to help his friend and **called the school nurse**.",
      description: "Jake **stopped immediately** to help his friend and **called the school nurse**.",
      image_url: "/images/week33/webtoon_scene_3.png",
      audio_url: "/audio/week33/scene_3.mp3",
      lexical_chunks: [
        { word: "stopped", chunk: "stopped immediately", vi: "dừng lại ngay lập tức", x: 46, y: 62 },
        { word: "nurse", chunk: "called the school nurse", vi: "gọi y tá trường", x: 53, y: 39 },
        { word: "help", chunk: "help his friend", vi: "giúp bạn mình", x: 34, y: 62 }
      ]
    },
    {
      scene_id: "scene_4",
      scene_number: 4,
      title_en: "Scene 4: Nurse Arriving with Bandage",
      description_en: "The nurse **arrived quickly** with a **clean bandage** and a **cold pack** to **treat the cut**.",
      description: "The nurse **arrived quickly** with a **clean bandage** and a **cold pack** to **treat the cut**.",
      image_url: "/images/week33/webtoon_scene_4.png",
      audio_url: "/audio/week33/scene_4.mp3",
      lexical_chunks: [
        { word: "nurse", chunk: "arrived quickly", vi: "đến nhanh chóng", x: 27, y: 42 },
        { word: "bandage", chunk: "clean bandage", vi: "băng sạch", x: 38, y: 68 },
        { word: "cut", chunk: "treat the cut", vi: "điều trị vết thương", x: 46, y: 69 }
      ]
    },
    {
      scene_id: "scene_5",
      scene_number: 5,
      title_en: "Scene 5: Relief & Safety Reminder",
      description_en: "Everyone **felt relieved**, and the headmaster **reminded all students** never to run in corridors.",
      description: "Everyone **felt relieved**, and the headmaster **reminded all students** never to run in corridors.",
      image_url: "/images/week33/webtoon_scene_5.png",
      audio_url: "/audio/week33/scene_5.mp3",
      lexical_chunks: [
        { word: "headmaster", chunk: "the headmaster", vi: "thầy hiệu trưởng", x: 58, y: 32 },
        { word: "relieved", chunk: "felt relieved", vi: "cảm thấy nhẹ nhõm", x: 78, y: 50 },
        { word: "reminded", chunk: "reminded all students", vi: "nhắc nhở tất cả học sinh", x: 44, y: 52 }
      ]
    }
  ],

  retell_questions: [
    {
      step: 1,
      question_vi: 'Chuyện đó bắt đầu ở đâu và như thế nào?',
      question_en: 'Where and how did the story begin?',
      chips: ['after science class', 'walking carefully', 'school corridor'],
      sentence: 'Right after science class, Jake walked carefully down the quiet school corridor.'
    },
    {
      step: 2,
      question_vi: 'Điều gì đã xảy ra đột ngột trên sàn ướt?',
      question_en: 'What happened suddenly on the wet floor?',
      chips: ['lost his balance', 'wet floor', 'slipped'],
      sentence: 'While running past the science room, Tom lost his balance on the wet floor and slipped.'
    },
    {
      step: 3,
      question_vi: 'Jake đã làm gì ngay lập tức để giúp bạn mình?',
      question_en: 'What did Jake do immediately to help his friend?',
      chips: ['stopped immediately', 'help his friend', 'called the school nurse'],
      sentence: 'To help his friend stay calm, Jake stopped immediately and called the school nurse right away.'
    },
    {
      step: 4,
      question_vi: 'Cô y tá đã làm gì để điều trị vết thương?',
      question_en: 'What did the nurse do when she arrived?',
      chips: ['arrived quickly', 'clean bandage', 'treat the cut'],
      sentence: 'To treat the cut, the nurse arrived quickly with a clean bandage and a cold ice pack.'
    },
    {
      step: 5,
      question_vi: 'Mọi người cảm thấy thế nào và thầy hiệu trưởng nhắc nhở điều gì?',
      question_en: 'How did everyone feel, and what did the headmaster remind students?',
      chips: ['felt relieved', 'the headmaster', 'reminded all students'],
      sentence: 'After everyone felt relieved, the headmaster reminded all students never to run in corridors.'
    }
  ],

  story_title_options: {
    question_en: "Now choose the best title for the story:",
    question_vi: "Bây giờ hãy chọn tiêu đề hay nhất cho câu chuyện:",
    options: [
      { id: "opt_a", text: "Tom's Clumsy Morning", is_correct: false, explanation: "Incorrect: The accident happened in the school corridor after science class, and the main theme is school safety and quick first aid." },
      { id: "opt_b", text: "Corridor Safety & Quick Action", is_correct: true, explanation: "Correct! The story describes corridor safety, Jake's quick action, and first aid treatment." },
      { id: "opt_c", text: "Playing Soccer in Science Class", is_correct: false, explanation: "Incorrect: Soccer is not played in the science class." }
    ]
  },

  social_story: {
    id: "w33_social",
    title_en: "School Safety Rules and Citizenship",
    title_vi: "Quy Tắc An Toàn Trường Học & Ý Thức Trách Nhiệm",
    content_en: "School safety rules help protect every student each day. In ancient schools and modern academies, following rules creates a peaceful environment. When students walk calmly in hallways, accidents do not happen. Helping an injured friend shows kindness and responsibility. Good citizens always care for others.",
    content_vi: "Các quy tắc an toàn trường học giúp bảo vệ mọi học sinh mỗi ngày. Trong các trường học cổ đại và học viện hiện đại, việc tuân thủ quy tắc tạo nên một môi trường hòa bình. Khi học sinh đi bộ bình tĩnh trong hành lang, tai nạn sẽ không xảy ra. Giúp đỡ một người bạn bị thương thể hiện lòng tốt và tinh thần trách nhiệm. Những công dân tốt luôn quan tâm đến người khác.",
    audio_url: "/audio/week33/read_social.mp3"
  }
};
